import * as React from 'react';
import {
  Dialog,
  DialogSurface,
  DialogTitle,
  DialogTrigger,
  DialogBody,
  DialogContent,
  Button,
  makeStyles,
  DialogProps,
  tokens,
  mergeClasses,
} from '@fluentui/react-components';
import { Dismiss24Regular } from '@fluentui/react-icons';
import { CopilotIcon } from '@bingads-webui-react/copilot-ui-base';

const useInlineCopilotDialogStyles = makeStyles({
  dialogBody: {},
  title: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: tokens.spacingVerticalS,
    fontSize: tokens.fontSizeBase400,
    lineHeight: tokens.lineHeightBase500,
  },
  titleIcon: {
    width: tokens.spacingVerticalXL,
    height: tokens.spacingVerticalXL,
    marginRight: tokens.spacingHorizontalSNudge,
    paddingLeft: tokens.spacingHorizontalNone,
    paddingRight: tokens.spacingHorizontalNone,
    paddingTop: tokens.spacingVerticalNone,
    paddingBottom: tokens.spacingVerticalNone,
  },
});

interface IInlineCopilotDialogProps {
  open: boolean;
  onOpenChange: DialogProps['onOpenChange'];
  title: React.ReactNode;
  closeButtonLabel?: string;
  children: React.ReactNode;
  modalType?: DialogProps['modalType'];
  className?: string;
  isNewLogo?: boolean;
}

export const InlineCopilotDialog: React.FC<IInlineCopilotDialogProps> = React.memo(({
  title,
  children,
  open,
  onOpenChange,
  closeButtonLabel,
  modalType,
  className,
  isNewLogo,
}) => {
  const styles = useInlineCopilotDialogStyles();

  return (
    <Dialog
      modalType={modalType}
      open={open}
      onOpenChange={onOpenChange}
    >
      <DialogSurface className={className}>
        <DialogBody className={mergeClasses(styles.dialogBody, 'inline-copilot-dialog-body')}>
          <DialogTitle
            className={styles.title}
            action={(
              <DialogTrigger action="close">
                <Button
                  aria-label={closeButtonLabel}
                  appearance="subtle"
                  className="inline-copilot-dialog-close-button"
                  icon={<Dismiss24Regular />}
                />
              </DialogTrigger>
            )}
          >
            <CopilotIcon iconStyles={styles.titleIcon} size="small" color={isNewLogo ? 'multicolor' : 'blue'} />
            {title}
          </DialogTitle>
          <DialogContent>
            {children}
          </DialogContent>
        </DialogBody>
      </DialogSurface>
    </Dialog>
  );
});

InlineCopilotDialog.defaultProps = {
  closeButtonLabel: 'Close',
  modalType: 'alert',
};
